import type { ImageLabelProps } from 'src/components/atoms/ImageLabel/ImageLabel';
import { ImageLabelColor } from 'src/components/atoms/ImageLabel/ImageLabel';

interface UseImageLabelArgs {
  hasStock: boolean;
  isNew: boolean;
  salePercentage: number;
  unavailable: boolean;
}

export const useImageLabel = ({
  hasStock,
  isNew,
  salePercentage = 0,
  unavailable,
}: UseImageLabelArgs): ImageLabelProps | null => {
  if (unavailable) {
    return {
      text: 'UNAVAILABLE',
      color: ImageLabelColor.Grey,
    };
  }

  if (!hasStock) {
    return {
      text: 'OUT OF STOCK',
      color: ImageLabelColor.Grey,
    };
  }

  if (salePercentage > 0) {
    return {
      text: `${salePercentage}% OFF`,
      color: ImageLabelColor.Red,
    };
  }

  if (isNew) {
    return {
      text: 'NEW IN',
      color: ImageLabelColor.Green,
    };
  }

  return null;
};
